import { formatPrice } from '@spotahome/soyuz-currency';
import { trans } from '@spotahome/soyuz/client';

export const canShowModal = rule =>
  rule?.allowedTypes || rule?.price || rule?.additionalInfo;

const PetsAllowedModal = ({ rule, currency }) => {
  const price = rule.price ? formatPrice(rule.price, currency) : null;
  return (
    <div>
      {rule.allowedTypes ? (
        <p>
          <b>{trans('property.rule.feature.petsAllowed.allowedTypes')}</b>{' '}
          {rule.allowedTypes}
        </p>
      ) : null}
      {rule.additionalInfo ? (
        <p>
          <b>{trans('property.rule.feature.petsAllowed.livingInProperty')}</b>{' '}
          {rule.additionalInfo}
        </p>
      ) : null}
      {price ? (
        <p>
          {trans('property.rule.feature.petsAllowed.checkPricing', {
            price
          })}
        </p>
      ) : null}
    </div>
  );
};

export default PetsAllowedModal;
